export default "__VITE_ASSET__D1li3yt7__"